'use client'

import * as styles from './NavBar.css'
import { useEffect } from 'react'
import { usePathname } from 'next/navigation'
import { useScrollbarOffset } from '@shared/hooks/useScrollLock'
import { isGhostStore } from './NavBarSearch'
import { GHOST_THRESHOLD, useIsTop } from './hooks'
import NavbarContent from './NavBarContent'

export default function NavBarWrapper() {
  const isTop = useIsTop(GHOST_THRESHOLD)
  const isHome = usePathname() === '/'
  const ghost = isHome && isTop

  useEffect(() => {
    isGhostStore.set(ghost)
  }, [ghost])

  return (
    <nav
      className={`${styles.root} ${ghost ? styles.ghost : ''} ${isHome ? styles.isHome : ''}`}
      style={{
        marginRight: useScrollbarOffset(),
      }}
    >
      <NavbarContent ghost={ghost} />
    </nav>
  )
}
